import { Field } from "enums";
import Validation from "services/validation.service";
import lang from "translations";

const sectionFormState = (initialState = {}) => {
  const {
    name = "",
    isActive = true,
  } = initialState;

  return {
    name: {
      name: "name",
      value: name,
      type: Field.INPUT,
      label: lang.name,
      validations: [Validation.required()],
      required: true,
      maxLength: 75,
    },
    locationId: {
      name: "locationId",
      value: initialState.locationId || "",
      type: Field.DROPDOWN,
      label: lang.location,
      validations: [Validation.required()],
      required: true,
    },
    isActive: {
      name: "isActive",
      value: isActive,
      type: Field.CHECKBOX,
      label: lang.active,
    },
  };
};

export default sectionFormState;